import request from '@/utils/request'

export function confirmCurrPoint(params) {
    return request({
        url: '/v2/sec/pg/confirmCurrPoint',
        method: 'post',
        data: params
    })
}

export function getCurrPoint(params) {
    return request({
        url: '/v2/sec/pg/getCurrPoint',
        method: 'post',
        data: params
    })
}
